<div class="card card-custom h-100">
    <div class="card-header align-items-center border-0">
        <div class="card-title">
            <span class="card-icon">
                <i class="fas fa-user-plus text-primary"></i>
            </span>
            <h3 class="card-label text-primary">
                {{"RecentTenants" | localize}} 
                <small class="text-muted" *ngIf=" recentTenantsData?.recentTenants?.length != 0">
                    {{"RecentTenantsHelpText" | localize:recentTenantsData?.recentTenantsDayCount : recentTenantsData?.maxRecentTenantsShownCount}}
                </small>
            </h3>
        </div>
    </div>
    <div class="card-body" [perfectScrollbar]>
        <div class="scroller-footer d-flex justify-content-end mb-3" *ngIf="recentTenantsData">
            <div class="btn-arrow-link">
                <a href="javascript:;" class="see-all-recent-tenants"
                   (click)="gotoAllRecentTenants()">{{"SeeAllRecords" | localize}}</a>
                <i class="icon-arrow-right"></i>
            </div>
        </div>
        <div class="scroller chart" [perfectScrollbar]>
            <div class="primeng-datatable-container recent-tenants-table" *ngIf="!loading"
                 [busyIf]="primengTableHelper.isLoading">
                <p-table #RecentTenantsTable [value]="recentTenantsData.recentTenants"
                         rows="{{primengTableHelper.defaultRecordsCountPerPage}}" [paginator]="false"
                         [lazy]="false">
                    <ng-template pTemplate="header" *ngIf="recentTenantsData?.recentTenants?.length != 0">
                        <tr>
                            <th>{{'TenantName' | localize}}</th>
                            <th>{{'CreationTime' | localize}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-record="$implicit">
                        <tr>
                            <td>
                                <span class="p-column-title">{{'TenantName' | localize}}</span>
                                {{record.name}}
                            </td>
                            <td>
                                <span
                                    class="p-column-title">{{'CreationTime' | localize}}</span>
                                {{ record.creationTime | luxonFormat:'F'}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="note note-info d-flex flex-column justify-content-center align-items-center" *ngIf="recentTenantsData?.recentTenants?.length == 0">
           
                    <div class="w-160px">
                
                        <div class="w-160px">
                            <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg"
                                class="w-100">
                        </div>
                    </div>
                    <h6 class="text-muted text-center mt-5">{{"NoDataFound" | localize}}</h6>
                </div>
            </div>
        </div>
    </div>
</div>
